import styled from 'styled-components';
import PhoneInput from 'react-phone-input-2'
import { Link } from 'react-router-dom';

export const UFContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    font-size: 0.9rem;
`

export const UFBody = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    margin-top: 0.2rem;
`

export const UFHeaderTitle = styled.h4`
    font-size: 1.5rem;
    font-weight: bold;
    color: ${({theme}) => theme.colors.lightBlue};
`

export const EntContainer = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const EIFormContainer2 = styled.div`
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding:5px ;


`;

export const EntHeaderWrapper = styled.div`
   width: 100%;
  /* height: 100%; */
  display: flex;
  justify-content: space-between;
  padding-bottom: 0.7rem;
  align-items: center;
  border-bottom: 3px solid #f5fbff;
           @media (max-width: ${({ theme }) => theme.size.laptopL}) {
   flex-direction: column;
  }
`;

export const EntHeader = styled.div`
    min_width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: baseline;
`;

export const EntHeaderTitleDiv = styled.div`
 display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: baseline;

`

export const EntHeaderTitle = styled.h4`
    font-size: 1.3rem;
    font-weight: normal;
    color: ${({ theme,color }) =>color?color: theme.colors.primary};
`

export const EntHeaderTitle2 = styled.h4`
    font-size: 0.9rem;
    font-weight: bold;
    color: #809FB8;
`

export const EntHeaderActions = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    flex: 1;
`

export const EntContent = styled.div`
    width: 100%;
`;


export const EntFormList = styled.div`
    width: 100%;
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    align-items: flex-start;
`;

export const EntFormItem = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 0.8rem;
    padding: 0.15rem;
    background-color: ${({ theme, color }) => color ? color : '#2174B980'};   
    color: white;
    border-radius: 6px;
    margin: 0.125rem;

    & span {
        margin: 0 0.5rem 0 0;
    }
`

export const OptionContainer = styled.div`
    height: 10px;
    display: flex;
    border-radius: 8px;
    align-items: center;
    width: 100%;
    justify-content: space-around;
    //    border-bottom: 1px solid #e9ecef;
    padding-bottom: 1.6rem;
`;

export const OptionDiv = styled.div`
  display: flex;
  align-items: center;
  gap: 0.2rem;
  margin-top:10px;
  cursor: pointer;
  user-select: none;
  &:hover {
    opacity: 0.8;
  }
    border-bottom: 1px solid #e9ecef;
  
`;
